// Framework
import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import MainFrame from '../views/MainFrame.vue'
import Dashboard from '../views/Dashboard.vue'

// Editor pages
//import ContentManager from '../views/content/ContentManager.vue'
import ContentEditor from '../views/content/ContentEditor.vue'
import MediaLibrary from '../views/content/MediaLibrary.vue'

// Dev pages
import ViewsEditor from '../views/dev/ViewsEditor.vue'
import CodeTemplates from '../views/dev/CodeTemplates.vue'
import DatabaseCreator from '../views/dev/DatabaseCreator.vue'

// Admin users
import AdminUsers from '../views/admin/users/AdminUsers.vue'
import Users from '../views/admin/users/Users.vue'
import NewUser from '../views/admin/users/NewUser.vue'

// Admin clients/groups/projects
import AdminProjects from '../views/admin/projects/AdminProjects.vue'
import Clients from '../views/admin/projects/Clients.vue'
import Groups from '../views/admin/projects/Groups.vue'
import Projects from '../views/admin/projects/Projects.vue'
import ProjectsDisabled from '../views/admin/projects/ProjectsDisabled.vue'
import NewClient from '../views/admin/projects/NewClient.vue'
import NewGroup from '../views/admin/projects/NewGroup.vue'
import NewProject from '../views/admin/projects/NewProject.vue'

// Export data to use for offline app
import DevExport from '../views/admin/DevExport.vue'


// ----------------------------------
//	Vue router
// ----------------------------------

Vue.use(VueRouter)

const routes = 
[
	{
		path: '/',
		name: 'MainFrame',
		component: MainFrame,
		children:
		[
			{
				path: "/",
				name: "Dashboard",
				component: Dashboard
			},
			{
				path: "/contenteditor/:key",
				name: "ContentEditor",
				component: ContentEditor
			},
			{
				path: "/media/:key",
				name: "MediaLibrary",
				component: MediaLibrary
			},
			{
				path: "/viewseditor/:key",
				name: "ViewsEditor",
				component: ViewsEditor
			},
			{
				path: "/codetemplates/:key",
				name: "CodeTemplates",
				component: CodeTemplates
			},
			{
				path: "/database/:key",
				name: "DatabaseCreator",
				component: DatabaseCreator
			},
			{
				path: "/admin",
				name: "AdminUsers",
				component: AdminUsers,
				children:
				[
					{
						path: "/admin/users/:state",
						name: "Users",
						component: Users
					},
					{
						path: "/admin/newuser",
						name: "NewUser",
						component: NewUser
					}
				]
			},
			{
				path: "/admin",
				name: "AdminProjects",
				component: AdminProjects,
				children:
				[
					{
						path: "/admin/clients",
						name: "Clients",
						component: Clients
					},
					{
						path: "/admin/groups",
						name: "Groups",
						component: Groups
					},
					{
						path: "/admin/projects",
						name: "Projects",
						component: Projects
					},
					{
						path: "/admin/disabledprojects",
						name: "ProjectsDisabled",
						component: ProjectsDisabled
					},
					{
						path: "/admin/newclient",
						name: "NewClient",
						component: NewClient
					},
					{
						path: "/admin/newgroup",
						name: "NewGroup",
						component: NewGroup
					},
					{
						path: "/admin/newproject",
						name: "NewProject",
						component: NewProject
					}
				]
			},
			{
				path: "/devexport/:key",
				name: "DevExport",
				component: DevExport,
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: LoginPage
	},
	{
		path: "*",
		name: "Login2",
		component: LoginPage
	},
]

const router = new VueRouter
({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router